import React, { forwardRef } from "react";
import { IoClose } from "react-icons/io5";
import Logo from "../common/Logo";
import { Link } from "react-router-dom";
import { ROUTES, STORES } from "../../configs";
import AuthButton from "../features/AuthButton";
import StoreCard from "../features/StoreCard";
import { useTypedSelector } from "../../store";

interface SideMenuProps {
  show: boolean;
  onClose: () => void;
}

const SideMenu = forwardRef<HTMLDivElement, SideMenuProps>(
  ({ show, onClose }, ref) => {
    const { user } = useTypedSelector((state) => state.session);
    const renderedStores = STORES.map((store, index) => (
      <StoreCard
        key={index}
        title={store.title}
        imagePath={store.imagePath}
      />
    ));

    return (
      <div
        ref={ref}
        className={`fixed top-0 left-0 h-full w-full lg:w-1/4 bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out ${
          show ? "translate-x-0" : "-translate-x-full"
        }`}
        onClick={onClose}
      >
        <div className="flex flex-col h-full justify-between">
          <div>
            <div className="relative items-center justify-between p-4 border-b">
              <Logo className="mx-auto" />
              <IoClose
                className="absolute w-8 h-8 cursor-pointer right-1 top-1"
                onClick={onClose}
              />
            </div>

            <nav className="flex flex-col p-4 space-y-4 text-lg font-semibold text-gray-700">
              <Link
                to={ROUTES.RESTAURANT_REQUEST}
                className="hover:text-primary"
                onClick={onClose}
              >
                Ajouter mon restaurant
              </Link>
              <Link
                to={ROUTES.RIDER_REQUEST}
                className="hover:text-primary"
                onClick={onClose}
              >
                Devenir coursier
              </Link>
              {user?.accessToken && (
                <>
                  <Link
                    to={ROUTES.PROFILE}
                    className="hover:text-primary"
                    onClick={onClose}
                  >
                    Mon profil
                  </Link>
                  <Link
                    to={ROUTES.CURRENT_ORDERS}
                    className="hover:text-primary"
                    onClick={onClose}
                  >
                    Mes commandes en cours
                  </Link>
                  <Link
                    to={ROUTES.ORDERS_HISTORY}
                    className="hover:text-primary"
                    onClick={onClose}
                  >
                    Mes commandes
                  </Link>
                </>
              )}
            </nav>
          </div>

          {/* Footer (bottom element) */}
          <div className="flex flex-col gap-2 p-4 border-t text-center text-gray-500">
            <AuthButton className="w-full text-center" />
            {renderedStores}
          </div>
        </div>
      </div>
    );
  }
);

SideMenu.displayName = "SideMenu";
export default SideMenu;
